import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from "@angular/material/dialog";
import { MatSnackBar } from '@angular/material';

@Component({
  selector: 'app-note-dialog',
  templateUrl: './note-dialog.component.html',
  styleUrls: ['./note-dialog.component.scss']
})
export class NoteDialogComponent implements OnInit {
  title: string;

  message: string;
  name: string;
  description: string;
  confirm_action: Function;
  selected_file: any;
  useremail: string;

  constructor(
    private dialogRef: MatDialogRef<NoteDialogComponent>,
    public snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) { title, message, name, description, useremail, confirm_action, selected_file }
  ) {
    this.title = title;
    this.message = message;
    this.name = name;
    this.description = description;
    this.confirm_action = confirm_action;
    this.selected_file = selected_file;
    this.useremail = useremail;
  }

  ngOnInit() {
  }

  confirm() {
    let addedNote = this.confirm_action(
      this.selected_file,
      {
        title: this.title,
        message: this.message,
        description: this.description,
        name: this.name,
        useremail: this.useremail,
      })
    this.snackBar.open(`The note ${addedNote} has been added.`, null, { duration: 5000 })
    this.close()
  }

  close() {
    this.dialogRef.close()
  }

}
